import { render, staticRenderFns } from "./TeamGoals.vue?vue&type=template&id=4e8ba479&scoped=true&"
import script from "./TeamGoals.vue?vue&type=script&lang=js&"
export * from "./TeamGoals.vue?vue&type=script&lang=js&"
import style0 from "./TeamGoals.vue?vue&type=style&index=0&id=4e8ba479&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8ba479",
  null
  
)

export default component.exports